import { SourceType } from './field-meta';

export enum QueryCombinerType {
  Any = 'any',
  All = 'all',
}

/** Shared with `components/pages/types` — keep in sync with SourceType. */
export enum FilterGroupType {
  Task = SourceType.Task,
  Project = SourceType.Project,
  User = SourceType.User,
  Phase = SourceType.Phase,
  Timesheet = SourceType.Timesheet,
  Role = SourceType.Role,
  StarMeta = SourceType.StarMeta,
  ActualStarMeta = SourceType.ActualStarMeta,
  EstimatedStarMeta = SourceType.EstimatedStarMeta,
  ResourceRequest = SourceType.ResourceRequest,
  Invoice = SourceType.Invoice,
  CreditNote = SourceType.CreditNote,
  Financial = SourceType.Financial,
  Company = SourceType.Company,
  Formula = SourceType.Formula,
  Expense = SourceType.Expense,
  Sheet = SourceType.Sheet,
  ExpenseReport = SourceType.ExpenseReport,
  RevenueEntry = SourceType.RevenueEntry,
  Policy = SourceType.Policy,
  ProjectFinancialBudget = SourceType.ProjectFinancialBudget,
  ResourceAllocation = SourceType.ResourceAllocation,
  Signal = SourceType.Signal,
}

/** API-layer filter shape; UI uses the richer type from `organisms/tasks/filters`. */
export type FieldFilter = {
  field?: {
    type?: string;
    fieldName?: string;
    fieldId?: number;
    sourceType?: SourceType;
    [key: string]: unknown;
  };
  id?: string;
  isGroup?: boolean;
  groupCriteria?: FieldFilter[];
  combinerType?: QueryCombinerType;
  [key: string]: unknown;
};

export interface GroupCriteria {
  id: FilterGroupType;
  criteria: FieldFilter;
  key?: string;
}

export interface GroupedFilter {
  type: QueryCombinerType;
  defaultGroup: FilterGroupType;
  groupCriteria: GroupCriteria[];
  nestedFilters?: GroupedFilter[];
}

export interface RecentlyAssignedFilter {
  noOfDays: number;
  sort: string;
}
